var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49098 4.5C8.44098 4.5 10.541 4.9 11.991 6C13.441 4.9 15.5507 4.5 17.5007 4.5C18.9507 4.5 20.4907 4.72 21.7707 5.29C22.5007 5.62 22.9907 6.33 22.9907 7.14V18.42C22.9907 19.73 21.7707 20.69 20.5107 20.36C19.5307 20.11 18.4907 20 17.4907 20C15.9307 20 14.2707 20.25 12.9307 20.92C12.6361 21.0698 12.3093 21.1448 11.991 21.145C11.6726 21.1448 11.3556 21.0698 11.061 20.92C9.72098 20.25 8.06098 20 6.50098 20C5.50098 20 4.46098 20.11 3.48098 20.36C2.22098 20.69 1.00098 19.73 1.00098 18.42V7.14C1.00098 6.33 1.49098 5.62 2.22098 5.29C3.50098 4.72 5.04098 4.5 6.49098 4.5ZM4.19098 18.21C3.57098 18.32 2.99098 17.86 2.99098 17.23V7.76C2.99098 7.29 3.33098 6.88 3.79098 6.78C4.66098 6.59 5.57098 6.5 6.49098 6.5C8.19098 6.5 10.641 7.15 11.991 8C13.341 7.15 15.8007 6.5 17.5007 6.5C18.4207 6.5 19.3307 6.59 20.2007 6.78C20.6607 6.88 21.0007 7.29 21.0007 7.76V17.23C21.0007 17.86 20.4207 18.32 19.8007 18.21C19.0507 18.07 18.2707 18.01 17.5007 18.01C15.8007 18.01 13.3507 18.66 12.0007 19.51C10.6507 18.66 8.19098 18.01 6.49098 18.01C5.72098 18.01 4.94098 18.07 4.19098 18.21Z",
    fill: "#22292F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 20,
    stroke: "#22292F",
    strokeWidth: 1.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.e2b216491d184ac8ea69963618535248.svg";
export { ForwardRef as ReactComponent };